import { TranslateProvider, type Translate } from "@similarweb/i18n-provider";

export { TranslateContext as TranslationContext } from "@similarweb/i18n-provider";
export type ITranslateProp = {
    translate: Translate;
};
export default TranslateProvider;
